import { gridPopUpEditorStyle, deleteColumnModalStyle } from '@bingads-webui-campaign-react/common-styles';
import { merge } from '@bingads-webui/primitive-utilities';
import getTableStyles from './table';
import getColGroupStyles from './col-group';
import getSubComponentStyles from './sub-component';
import getGlobalStyles from './global';
import { gridPaddingLeft } from './variables';

export const getStyles = (components, { palette = {} }) =>
  ({
    grid: {
      fontFamily: 'Segoe UI',
      '& .bingadsgrid': {
        paddingLeft: gridPaddingLeft,
      },
      '& .table-container': {
        '& colgroup.column-group': getColGroupStyles(components, { palette }),
        '& table.table': getTableStyles(components, { palette }),
        '&': getSubComponentStyles(components, { palette }),
      },
    },
    '@global': merge(
      {},
      getGlobalStyles(components, { palette }),
      gridPopUpEditorStyle({ palette }),
      deleteColumnModalStyle()
    ),
  });
